import type { Locale } from './studioLocale';

const english: Record<string, string> = {
  "剧本改编": "Script adaptation",
  "有声剧制作": "Audio drama",
  "呆板化研究": "Script diversity research",
  "高级画布": "Advanced canvas",
  "分阶段盲审": "Staged blind review",
  "工作区已连接": "Workspace connected",
  "访客模式": "Visitor mode",
  "导入原著，": "Import a book,",
  "开始改编剧本。": "adapt it for the screen.",
  "用织梦读取原著、比较场面试写，调整人物和前后场，完成改编剧本。也可以从头创作原创剧本。生成时使用你的 API Key。": "SceneWeave reads the source, compares scene trials, and revises characters and connected scenes to complete an adaptation. You can also write an original script. Generation uses your API key.",
  "开始改编 →": "Start adapting →",
  "原创短剧": "Original short drama",
  "游客工作区": "Visitor workspace",
  "自带 API Key": "Bring your API key",
  "原著证据可追溯": "Traceable source passages",
  "使用你的模型额度": "Use your own model access",
  "导入 TXT、Markdown 或 EPUB，分块读完整部原著，比较两种场面写法，再形成完整剧本。": "Import TXT, Markdown or EPUB. Read the entire book in chunks, compare two scene treatments, and develop a complete screenplay.",
  "进入改编工作台 →": "Open adaptation studio →",
  "上传 EPUB 原著，建立全书方案与分集制作项目，并试听作品库。": "Upload an EPUB, develop a whole-book plan and episode scripts, and explore published audio dramas.",
  "进入制作与作品库 →": "Open production and library →",
  "剧本呆板化研究": "Script diversity research",
  "探索后训练对剧本有效多样性的影响，通过分阶段盲审连接文本与评价证据。": "Explore script diversity through staged blind comparisons of texts and evaluation evidence.",
  "查看研究与盲审 →": "View research and reviews →",
  "继续创作": "Continue writing",
  "当前工作区": "Current workspace",
  "还没有项目": "No project yet",
  "保留节点、连接、生成结果和修改历史": "Continue with your story elements, connections, scripts and edits",
  "继续 →": "Continue →",
  "先新建短剧": "Create a script first",
  "最近生成": "Recent generations",
  "生成任务": "Generation",
  "新建项目后，分阶段生成记录会出现在这里。": "Generation history will appear here after you start a project.",
  "原创创作工具": "Original writing tools",
  "竖屏短剧": "Vertical short drama",
  "电影剧本": "Film screenplay",
  "你的模型服务": "Your model provider",
  "只在当前页面会话中使用": "Used only in this page session",
  "启用": "Enable",
  "清除": "Clear",
  "连接正常": "Connection successful",
  "连接失败": "Connection failed",
  "测试中…": "Testing…",
  "测试连接": "Test connection",
  "请进入 HTTPS 安全入口后添加密钥": "Open the secure HTTPS site to add a key",
  "已启用文本模型": "Text model enabled",
  "原著导入与编辑无需密钥；模型生成需添加密钥。": "Importing and editing need no key. Add a key to generate text.",
  "密钥不会写入项目或浏览器存储。": "Keys are never saved in projects or browser storage.",
  "共用能力": "Shared capabilities",
  "文本生成用于原创剧本、小说改编和有声剧台本。词嵌入与检索优先复用 Qwen 或 OpenAI 密钥；DeepSeek 文本服务需要另填一枚 Qwen 密钥来运行词嵌入、语音与图像能力。": "Text generation supports original scripts, adaptations and audio-drama scripts. Retrieval reuses a Qwen or OpenAI key. With DeepSeek, add an optional Qwen key for embeddings, speech and images.",
  "Qwen API Key（词嵌入与媒体，可选）": "Qwen API key (embeddings and media, optional)",
  "同一密钥供词嵌入、语音、转写、图像使用": "One key for embeddings, speech, transcription and images",
  "启用 Qwen 能力": "Enable Qwen capabilities",
  "清除 Qwen 密钥": "Clear Qwen key",
  "Qwen 能力已配置": "Qwen capabilities configured",
  "如需对应能力，请填写 Qwen 密钥。": "Add a Qwen key if you need these capabilities.",
  "Qwen Workspace ID（音效、音乐、图像）": "Qwen Workspace ID (sound effects, music and images)",
  "开通音频模型后填写；其余能力可留空": "Required for enabled audio models; otherwise optional",
  "Workspace ID 已应用": "Workspace ID applied",
  "应用": "Apply",
  "分块阅读原著": "Reading source chunks",
  "整理全书脉络": "Combining whole-book readings",
  "构思改编": "Planning the adaptation",
  "写作初稿": "Writing the first draft",
  "比较改编方向": "Comparing adaptation directions",
  "试写关键场面": "Trying key scenes",
  "调整人物与前后场": "Revising characters and connected scenes",
  "写作完整剧本": "Writing the complete script",
  "审读剧本": "Reviewing the script",
  "整理修订意见": "Planning revisions",
  "修改相关场面": "Revising affected scenes",
  "（已完成）": "(reused)",
  "改编进行中": "Adaptation in progress",
  "改编正在进行，可以关闭窗口后继续查看。": "Adaptation is running. You can close this window and return later.",
  "改编完成，可以查看试写、修订依据和完整剧本。": "Adaptation complete. Review the scene trials, revisions and full screenplay.",
  "改编中断。已完成步骤已保留；重新提交相同原著可复用这些步骤。": "Adaptation interrupted. Completed steps are saved and can be reused when you submit the same source again.",
  "暂时无法读取进度，稍后会继续查询。": "Progress is temporarily unavailable. Checking will resume shortly.",
  "原著解析失败": "Could not read the source",
  "已提交改编，正在等待阅读原著。": "Adaptation submitted. Waiting to read the source.",
  "无法开始改编": "Could not start adaptation",
  "剧本改编 · 织梦": "Script adaptation · SceneWeave",
  "读原著，试写场面，完成改编": "Read the source, try scenes, develop an adaptation",
  "关闭": "Close",
  "全文按章节分块阅读，再比较两种场面写法，调整人物、前段准备和后续发展。所有写作与审读均使用 API。": "Read the entire source in chapter-based chunks, compare two scene treatments, then revise characters, preparation and subsequent development. All writing and reviewing uses APIs.",
  "文本模型 API Key": "Text model API key",
  "项目名（可选）": "Project title (optional)",
  "例如：雨夜失踪案": "For example: The Missing Key",
  "选择 TXT / Markdown / EPUB": "Choose TXT / Markdown / EPUB",
  "改用粘贴": "Paste text instead",
  "或粘贴原著正文": "Or paste the source text",
  "可导入完整长篇原著。最多500万字符；超出时会提示分卷，不截断正文。": "Import a complete book, up to 5 million characters. Larger works require separate volumes; text is never silently truncated.",
  "改编要求": "Adaptation requirements",
  "场面数量": "Number of scenes",
  "预览仅展示开头几条定位；生成时逐块读取全文，覆盖范围可在完成后查看。": "This preview shows only a few source passages. Generation reads every chunk; coverage is available on completion.",
  "人物与前后场的调整": "Changes to characters and connected scenes",
  "模型审读意见": "Model review notes",
  "部分意见未找到对应原句，已保留稿件，未据此自动修改。": "Some notes could not be matched to the draft. They were retained for inspection without automatically changing the text.",
  "完整改编剧本": "Complete adapted screenplay",
  "稍后继续查看": "Return later",
  "取消": "Cancel",
  "解析中…": "Reading…",
  "读取原著并预览": "Read source and preview",
  "提交中…": "Submitting…",
  "用织梦生成改编剧本": "Generate with SceneWeave",
  "写入工作台并编辑": "Open in workspace to edit",
  "改编为影视短剧。保留原著主要人物关系与重要选择，允许调整场面次序和表现方式。通过动作与对白呈现冲突，避免重复解释。": "Adapt this work into a short screen drama. Preserve its central relationships and consequential choices; scene order and presentation may change. Express conflict through action and dialogue, avoiding repetitive explanations.",
  "← Morphor 首页": "← Morphor home",
  "进入盲审": "Blind review",
  "大模型后训练与剧本呆板化": "Post-training and script diversity",
  "研究剧本的正确性、戏剧性与有效多样性。当前暂无可发布的模型比较结论。": "Studying correctness, dramatic action and effective diversity. No model-comparison findings are currently available for publication.",
  "研究问题": "Research question",
  "正确的剧本会不会越来越像？": "Do correct scripts become more alike?",
  "比较不同训练阶段的剧本，观察约束错误减少时，解决冲突的方法是否也变得单一。": "Compare scripts across training stages to examine how fewer constraint violations relate to the range of conflict resolutions.",
  "评价维度": "Evaluation dimensions",
  "从文本走向戏剧": "From text to drama",
  "分别看因果是否成立、角色是否主动行动、场景能否拍摄，以及结局是否带来情绪回报。": "Examine causal coherence, character agency, filmability and emotional payoff.",
  "主观评价": "Subjective evaluation",
  "匿名比较": "Anonymous comparison",
  "评价者先读场景要求和作品，再独立评分；评分时不显示作品的模型和生成条件。": "Reviewers read the scene brief and text before evaluating independently. Model identities and generation conditions remain hidden during evaluation.",
  "打开盲审页面 →": "Open blind review →",
  "上传小说，制作能听的戏。": "Turn a novel into audio drama.",
  "从 EPUB 原著开始，依次完成全书方案、分集台本、声音设计与成品质检。下方可试听已发布作品。": "Start with an EPUB, develop a whole-book plan and episode scripts, then proceed through sound design and production review. Listen to published works below.",
  "01 / 上传 EPUB 原著": "01 / Upload an EPUB",
  "单本不超过 12 MB": "Up to 12 MB per book",
  "作品名（可选）": "Title (optional)",
  "留空时读取 EPUB 书名": "Leave blank to use the EPUB title",
  "选择 EPUB 文件": "Choose an EPUB file",
  "正在导入…": "Importing…",
  "上传 EPUB 并建立项目": "Upload EPUB and create project",
  "作品目录暂时无法读取": "The library is temporarily unavailable",
  "导入失败": "Import failed",
  "台本任务提交失败": "Could not submit script generation",
  "台本读取失败": "Could not load the script",
  "台本流程已完成。": "Script generation complete.",
  "正在按全书方案、分集台本和审校流程生成。": "Developing the whole-book plan, episode scripts and review.",
  "台本任务已排队。": "Script generation queued.",
  "已建立原著证据与分集制作项目。模型密钥仅在点击生成后用于本次任务。": "Source passages and an episode project are ready. Your model key is used only after you start generation.",
  "用我的文本模型生成台本": "Generate scripts with my text model",
  "分集台本": "Episode scripts",
  "02 / 制作流程": "02 / Production workflow",
  "原著导入与篇幅判断": "Import and assess the source",
  "全书方案与证据审校": "Whole-book plan and source review",
  "分集台本与听众视角审校": "Episode scripts and listener review",
  "配音、音效、音乐与混音质检": "Voices, sound effects, music and mix review",
  "已完成": "Complete",
  "进行中": "In progress",
  "待启动": "Not started",
  "声音制作使用远程服务；本站不会在服务器上加载本地音频模型。": "Audio production uses remote services. This site does not load local audio models.",
  "作品库": "Library",
  "四部有声剧": "Audio drama collection",
  "试听已发布集数": "Listen to published episodes",
  "有声剧集数": "Audio drama episode",
  "本集配图": "Episode illustration",
  "有声剧 · 已发布": "Audio drama · Published",
  "本集台本": "Episode script",
  "试听与台本 →": "Listen and read →",
  "请先填写文本模型 API Key": "Add your text model API key first.",
  "请先进入游客工作区": "Enter a visitor workspace first.",
  "请填写改编要求": "Enter your adaptation requirements.",
  "请使用2至24场及不超过10000字符的改编要求": "Choose 2–24 scenes and keep the brief within 10,000 characters.",
  "请先添加自己的模型 API Key；本站不会使用服务器密钥": "Add your own model API key. This site does not use a server key.",
  "模型服务拒绝了 API Key，请检查服务商和权限": "The provider rejected your API key. Check the provider and permissions.",
  "模型服务限流，请稍后再试": "The provider is rate-limiting requests. Please try later.",
  "模型返回空内容，请调整输入或模型后再试": "The model returned no text. Review the input or model before resubmitting.",
  "模型请求超时，请缩短输入后重试": "The model request timed out. Review the input before resubmitting.",
  "模型服务暂时不可连接": "The model service is temporarily unreachable.",
  "API Key 格式无效": "Invalid API key format.",
  "这份旧底稿没有全文分块，请重新导入原著": "This older import has no full-source chunks. Import the source again.",
  "原著分块有缺失、重叠或超长，请重新导入": "Source chunks are missing, overlapping or too large. Import the source again.",
  "原著全文与分块索引不一致，请重新导入": "The source does not match its chunk index. Import the source again.",
  "该步骤仍在执行或上次响应未确认，请先查看原任务，避免重复计费": "This step is running or its previous response is unconfirmed. Check the original task before resubmitting.",
  "两种试写须采用确实不同的构思修改": "The two scene trials must apply distinct plan changes."
};

export const entryText = (locale: Locale, text: string): string => locale === 'en' ? (english[text] || text) : text;
